'use client'

import { useState } from 'react'

import styled from 'styled-components'

import { colors } from '../../../constants/colors'

interface ReferralCodeProps {
  referralCode?: string
}

export const ReferralCode = ({ referralCode }: ReferralCodeProps) => {
  const [copiedValue, setCopiedValue] = useState<'code' | 'link' | null>(null)
  const referralLink = referralCode
    ? `https://app.allsharing.su/register?referral=${referralCode}`
    : ''

  const copyValue = async (value: string, type: 'code' | 'link') => {
    if (!value) return

    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(value)
      } else {
        const textarea = document.createElement('textarea')
        textarea.value = value
        textarea.style.position = 'fixed'
        textarea.style.opacity = '0'
        document.body.appendChild(textarea)
        textarea.select()
        document.execCommand('copy')
        textarea.remove()
      }
      setCopiedValue(type)
      window.setTimeout(() => setCopiedValue(null), 1500)
    } catch {
      setCopiedValue(null)
    }
  }

  return (
    <Wrapper>
      <Title>Ваш реферальный код</Title>
      <CopyRow>
        <Value title={referralCode}>{referralCode || 'Загрузка…'}</Value>
        <CopyButton
          aria-label={'Скопировать реферальный код'}
          disabled={!referralCode}
          onClick={() => copyValue(referralCode || '', 'code')}
          type={'button'}
        >
          <img alt={''} src={'/images/main-menu/copy.svg'} />
        </CopyButton>
      </CopyRow>
      <CopyRow>
        <Value title={referralLink}>{referralLink || 'Загрузка…'}</Value>
        <CopyButton
          aria-label={'Скопировать реферальную ссылку'}
          disabled={!referralLink}
          onClick={() => copyValue(referralLink, 'link')}
          type={'button'}
        >
          <img alt={''} src={'/images/main-menu/copy.svg'} />
        </CopyButton>
      </CopyRow>
      <CopyStatus aria-live={'polite'}>
        {copiedValue === 'code' && 'Код скопирован'}
        {copiedValue === 'link' && 'Ссылка скопирована'}
      </CopyStatus>
    </Wrapper>
  )
}

const Title = styled.h4`
  margin: 0;
  color: #000;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`

const CopyRow = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 44px;
  padding: 12px 20px;
  border-radius: 10px;
  background: ${colors.lightGray};
`

const Value = styled.span`
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  color: ${colors.grey};
  font-size: 14px;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const CopyButton = styled.button`
  display: flex;
  flex: 0 0 20px;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;

  &:disabled {
    cursor: default;
    opacity: 0.45;
  }

  img {
    width: 20px;
    height: 20px;
    padding: 0.92px 1.75px;
  }
`

const CopyStatus = styled.span`
  position: absolute;
  top: 100%;
  left: 0;
  line-height: 18px;
  color: ${colors.primary};
  font-size: 12px;
`
